<template>
  <div class="w-full items-center">
    <div class="flex hidden">
      <gd-toggle 
        class="mx-2"
        bgClass="bg-secondary"
        v-model="overrideMode"
      />
    </div>

    <div class="w-full justify-center relative">
      <div class="flex justify-left mb-4 screenIcon">
        <span
          v-for="screen in screens"
          :key="screen"
          class="flex items-center w-auto heading-sm mr-2 ml-2 cursor-pointer"
        >
          <component
            :is="`${screen}-icon`"
            class="h-6 w-6 fill-current"
            :class="{
              'text-secondary-invert': !isSelected(screen) && !overrideMode,
              'text-primary': isSelected(screen) && !overrideMode,
              'text-secondary-invert': !isSelected(screen) && overrideMode,
              'text-primary': isSelected(screen) && overrideMode,
            }"
            @click="setScreenSize(screen)"
          ></component>
        </span>
      </div>
      <div class="w-full justify-center screenIcon">
        <div class="mb-1 ml-2 w-full">
          <gd-slider
            :readonly="false"
            class="logo-size-slider text-grey-600"
            :min="300"
            :max="1600"
            step="2"
            :value="previewWidth"
            @input="updatePreviewWidth"
          />
        </div>
      </div>
      <div class="screenHint text-center text-secondary-invert hidden">
        {{ screenText }}
      </div>
    </div>
  </div>
</template>
<script>
import GdToggle from '@groovepages/gd-ui-kit/components/Toggle';
import GdButton from '@groovepages/gd-ui-kit/components/Button';
import DesktopIcon from '@groovepages/gd-ui-kit/assets/desktop-icon.svg';
import LaptopIcon from '@groovepages/gd-ui-kit/assets/laptop-icon.svg';
import TabletVIcon from '@groovepages/gd-ui-kit/assets/tablet-v-fa.svg';
import TabletHIcon from '@groovepages/gd-ui-kit/assets/tablet-h.svg';
import MobileIcon from '@groovepages/gd-ui-kit/assets/mobile-icon-fa.svg';
import styleProperties from './styleProperties';

export default {
  components: {
    GdToggle,
    GdButton,
    'xl-icon': DesktopIcon,
    'lg-icon': LaptopIcon,
    'xs-icon': MobileIcon,
    'sm-icon': TabletVIcon,
    'md-icon': TabletHIcon,
  },
  props: ['dark'],
  data() {
    return {
      screens: ['xs', 'sm', 'md', 'lg', 'xl'],
    };
  },
  computed: {
    previewType: {
      get: function() {
        return this.screenSize == 'custom';
      },
      set: function(newValue) {
        if (newValue == true) {
          this.$store.commit('forms/SET_SCREEN_SIZE', 'custom');
          return;
        }
        this.$store.commit('forms/SET_SCREEN_SIZE', 'lg');
      }
    },
    screenSize() {
      return this.$store.state.forms.viewMode;
    },
    previewWidth() {
      return this.$store.state.forms.previewWidth;
    },
    overrideMode: {
      get() {
        return !this.$store.state.forms.singleScreenOverride;
      },
      set(value) {
        this.$store.commit('forms/SET_STYLE_OVERRIDE', !value);
      },
    },
    screenText() {
      if (this.overrideMode) {
        return this.$t('frontend_builder_applying_to_all');
      }
        switch (this.screenSize) {
          case 'xs':
            return this.$t('frontend_builder_applying_to_xs');
          case 'sm':
            return this.$t('frontend_builder_applying_to_sm');
          case 'md':
            return this.$t('frontend_builder_applying_to_md');
          case 'lg':
            return this.$t('frontend_builder_applying_to_lg');
          case 'xl':
            return this.$t('frontend_builder_applying_to_xl');
        }

    },
  },
  methods: {
    isSelected(size) {
      if (this.previewWidth === styleProperties.breakpoints[size].replace('px', '')) return true;
      return false;
    },
    setScreenSize(size) {
      let value = styleProperties.breakpoints[size].replace('px', '');
      this.$store.commit('forms/SET_PREVIEW_WIDTH', value);
    },
    updatePreviewWidth(value) {
      this.$store.commit('forms/SET_PREVIEW_WIDTH', value);
    },
  },
};
</script>

<style scoped>
.active {
  position: relative;
}

.active::after {
  content: '';
  position: absolute;
  width: 26px;
  height: 1px;
  top: 28px;
  left: 3px;
}

.screenHint {
  font-size: 0.625rem;
  margin-top: 5px;
  width: 100%;
  text-align: center;
  line-height: 10px;
  font-weight: 700;
}
</style>
